module.exports = __webpack_public_path__ + "static/media/17.017c8723.jpg";